import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Icon from '@atoms/Icon/Icon';
import IconTooltip from '@molecules/IconTooltip/IconTooltip';

export const StyledDetailsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledDetailsItemsContainer = styled.div`
  display: flex;
  width: 100%;
  height: ${rem(56)};
  margin: 0 ${rem(16)};
`;

export const StyledDetailsItem = styled.div`
  background-color: ${variables.colors.white};
  color: ${variables.colors.lighterBlack};
  align-items: center;
  display: flex;
  padding-bottom: ${rem(16)};

  &:not(:last-child) {
    padding-right: ${rem(16)};
  }

  &:last-child {
    flex: 1 1 auto;
    justify-content: flex-end;
  }
`;

export const StyledDetailsItemTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledExpressIcon = styled(Icon)`
  position: relative;
  top: ${rem(1)};
  padding-left: ${rem(5)};
`;

export const StyledIconTooltip = styled(IconTooltip)`
  margin-left: ${rem(8)};
`;
